import { cssSpacing } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Footer = styled.div.withConfig({
  displayName: "Footer",
  componentId: "sc-1eox67n-0"
})(["align-items:center;display:flex;justify-content:space-between;margin-block-end:calc(-1 * ", ");margin-inline-start:calc(-1 * ", ");padding-block-start:", ";"], cssSpacing('tighter-2', '8px'), cssSpacing('tighter-4', '4px'), cssSpacing('looser', '24px'));